import { MotionValue, motion } from "motion/react"


export const ParallaxedBg = ({bgY, backgroundImage}: {bgY: MotionValue<string>, backgroundImage: string}) => {
    
    return(
        <motion.div 
            style={{
                position: 'fixed',
                width: '100%',
                height: '100vh',
                backgroundImage: `url(${backgroundImage})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                filter:'grayscale(1) brightness(.5)',
                scale: 1.5,
                top: `0px`,
                y: bgY,
                zIndex: -1
            }}
        />
    )
}